import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePromoStore = defineStore('promo', () => {
  const promoTypes = ref([])

  function setPromoTypes(payload) {
    promoTypes.value = payload
  }

  return {
    // refs
    promoTypes,
    // computed

    //functions
    setPromoTypes,
  }
})
